import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IInsiderModalRequest) {
    (function(InsiderModalContext) {
        InsiderModalContext["INSIDER_MODAL_CONTEXT_UNKNOWN"] = "INSIDER_MODAL_CONTEXT_UNKNOWN";
        InsiderModalContext["MARKETING_PAGE"] = "MARKETING_PAGE";
        InsiderModalContext["MOBILE_HOME_FEED"] = "MOBILE_HOME_FEED";
        InsiderModalContext["BRAND_PAGE"] = "BRAND_PAGE";
        InsiderModalContext["PDP"] = "PDP";
        InsiderModalContext["CHECKOUT_SHOPPING_BAG"] = "CHECKOUT_SHOPPING_BAG";
        InsiderModalContext["CHECKOUT_SHIPPING_METHOD"] = "CHECKOUT_SHIPPING_METHOD";
        InsiderModalContext["REMIND_ME_LATER"] = "REMIND_ME_LATER";
        InsiderModalContext["SETTINGS_PAGE"] = "SETTINGS_PAGE";
        InsiderModalContext["CHECKOUT"] = "CHECKOUT";
    })(IInsiderModalRequest.InsiderModalContext || (IInsiderModalRequest.InsiderModalContext = {}));
    IInsiderModalRequest.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IInsiderModalRequest || (IInsiderModalRequest = {}));
export var IInsiderModalRequest;
